import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export function useArCustomerContacts(customerId: string) {
  const queryOptions =
    orpc.accountsReceivable.arCustomerContacts.list.queryOptions({
      input: { customerId },
      enabled: !!customerId,
    });

  const query = useQuery(queryOptions);

  return {
    ...query,
    contacts: query.data?.contacts ?? [],
  };
}
